import React from "react";
import './css/ContactStyle.css';

function Contact (){
  return (
        <section className="py-5">
          <div className="container text-center">
            <div className="divider"></div>
            <h2 className="section-title">Our <span>Locations</span></h2>
            <p className="text-muted mb-5">Enim lobortis scelerisque Consectetur erat nam magna etiam tempor orci. Sem et tortor consequat id. Fermentum egestas tellus. Nunc eu hendrerit turpis. Fusce non lectus sem In pellentesque nunc.</p>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>India</h5>
                  <hr />
                  <p><i className="bi bi-geo-alt-fill"></i>  Outram lane, GTB nagar, New Delhi, 110009</p>
                  <p><i className="bi bi-telephone"></i> +91-9717270400</p>
                  <p><i className="bi bi-envelope-at me-1"></i> info@vigyanvriksh.in</p>
                </div>
              </div>
              <div className="col-md-8">
                <div className="location-card1 text-start">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3786.578752370429!2d77.20791907569364!3d28.704312680817026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfdde3d2dee83%3A0x88abdb2639ea7060!2sVigyan%20Vriksh!5e1!3m2!1sen!2sin!4v1766908777122!5m2!1sen!2sin" width="100%" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
              {/* <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>Spain</h5>
                  <hr />
                  <p><i className="fa fa-map-marker-alt"></i> Calle del Codo, 2, New St, Murcia, 30880, Spain</p>
                  <p><i className="fa fa-phone"></i> 000 123 456789</p>
                  <p><i className="fa fa-envelope"></i> contact@example.com</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>France</h5>
                  <hr />
                  <p><i className="fa fa-map-marker-alt"></i> 96 Rue Oberkampf Street, Paris, France, 75011</p>
                  <p><i className="fa fa-phone"></i> 0000 123 456789</p>
                  <p><i className="fa fa-envelope"></i> support@example.com</p>
                </div>
              </div> */}
            </div>
          </div>
        </section>
    )
}
export default Contact;